import StyleSheet from 'react-native-extended-stylesheet';

export const style = StyleSheet.create({
  flex1: {
    flex: 1,
  },
  separationView: {
    width: '$space4',
  },
});
